import { twMerge } from "tailwind-merge";

import { ReactComponent as ZingPulseSVG } from "@/assets/icons/zing-pulse.svg";
import { Colors } from "@/constants/colors";
import { useGender } from "@/utils/GenderProvider";

interface ZingInfoBlockProps {
    text: string;
    className?: string;
}

const ZingInfoBlock = ({ text, className }: ZingInfoBlockProps) => {
    const { isFemale } = useGender();

    return (
        <div
            className={twMerge(
                "text-16-24 relative rounded-3xl border border-zing-cool-blue-500 bg-zing-cool-blue-800 px-8 py-6 text-white female:border-zing-warm-neon-green-500 female:bg-zing-warm-neon-green-100 female:text-black",
                className
            )}
        >
            {text}
            <ZingPulseSVG
                className="absolute -top-5 left-5"
                color={isFemale ? Colors.WARM_GREEN_400 : Colors.COOL_BLUE_500}
            />
        </div>
    );
};

export default ZingInfoBlock;
